// External Dependencies:
import React from 'react'
import { Link } from 'react-router-dom'

// Internal Dependencies:
import Image from 'church-theme-library/components/Image/Image'

class AdvertisementFaithFM extends React.Component {
	render() {
		return (
			<div className="section-advertisement-general section-advertisement-faith-fm">
				<div className="-inner">
					<div className="-text">
						<h2>Faith FM Radio</h2>

						<p>Our church supports Faith FM, a Christian radio network providing <strong>positively different</strong> lifestyle and spiritual radio programs to benefit, enhance and uplift Australian communities.</p>

						<p>Faith FM reaches approximately 6 million Australians through FM radio stations scattered around Australia, and reaches across the Outback through the VAST service (a government-sponsored radio and TV service to remote communities and grey nomads).</p>

						<p>Listen from your local station, online, or via the app.</p>

						<p className="with-button">
							<a href="https://faithfm.com.au/listen/" className="button" target="_blank" rel="noopener">Find out more</a>
						</p>
					</div>

					<div className="-image">
						<a href="https://faithfm.com.au/listen/" target="_blank" rel="noopener">
							<Image
								thumb={ `${siteData.images_url}sections/external/faith-fm-thumb.jpg` }
								url={ `${siteData.images_url}sections/external/faith-fm.jpg` }
								srcset={ null }
								sizes={ `(max-width: ${siteData.mobile_max_width}px) 100vw, 1100px` }
								alt="Faith FM Radio"
								width={ 1200 }
								height={ 1563 }
								aspectRatio={ 1200 / 1563 }
							/>
						</a>
					</div>
				</div>
			</div>
		)
	}
}

export default AdvertisementFaithFM
